import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
export default class BunkerTurnover extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      turnover: [],
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cistern !== this.props.cistern) {
      this.load();
    }
  }

  load = async () => {
    this.setState({ pending: true });
    let turnover = [];
    if (this.props.cistern) {
      turnover = await this.context.api.qa("/cistern/turnover/list", {
        filter: { cistern: this.props.cistern },
      });
    }
    this.setState({ pending: false, turnover: turnover || [] });
  };

  render() {
    const { item } = this.props;
    const { pending, turnover } = this.state;
    return (
      <Modal size="lg" show onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title className="w-100">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="text-muted mr-2">{item.shipname}</span>{" "}
                {item.label}
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Blocker on={pending} hAuto>
            <table className="table">
              <thead>
                <tr>
                  <th>Дата, время</th>
                  <th>Документ</th>
                  <th>Поступление</th>
                  <th>Списание</th>
                </tr>
              </thead>
              <tbody>
                {turnover.map((item, idx) => {
                  let line = item || {};
                  let doc = line.document || {};
                  let datetime = line.datetime ? new Date(line.datetime) : {};
                  return (
                    <tr key={idx}>
                      <td>{datetime.toLocaleString()}</td>
                      <td>
                        <Link to={`/workdoc/any/any/${line.document}/`}>
                          {line.label}
                        </Link>{" "}
                      </td>
                      <td>{line.credit}</td>
                      <td>{line.debit}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Blocker>
        </Modal.Body>
      </Modal>
    );
  }
}
